import { useState } from 'react';

import { RatingFeedbackChipsProps } from '../../../components/Ratings/RatingsFeedbackChips/RatingFeedbackChips.typed';
import { ReviewChipAggregationKeys } from '../../../api/types/adviewApiTypes';
import * as Styled from '../../../components/Ratings/RatingsFeedbackChips/RatingFeedbackChips.styled';
import { DisplayTag } from '../../../components/Ratings/DisplayTag/DisplayTag';

const RatingFeedbackChips = (props: RatingFeedbackChipsProps) => {
  const { userRating } = props;
  const { reviewChipAggregation } = userRating || {};
  const [selectedTab, setSelectedTab] =
    useState<ReviewChipAggregationKeys>('positive');

  const chips = reviewChipAggregation?.[selectedTab]?.chips || [];
  const hasChips = chips.length > 0;
  const chipShade = selectedTab === 'positive' ? 'GREEN' : 'GREY';

  const tabs = reviewChipAggregation
    ? (Object.keys(reviewChipAggregation) as ReviewChipAggregationKeys[]).map(
        (tabName) => ({
          label: (
            <Styled.TabItem>
              {reviewChipAggregation[tabName].displayName}
            </Styled.TabItem>
          ),
          value: tabName,
          isDisabled: false,
        }),
      )
    : [];

  const handleTabSelection = (tabValue: ReviewChipAggregationKeys) => {
    setSelectedTab(tabValue);
  };

  return (
    <Styled.Feedback>
      <Styled.ReviewTitle>What Others Say</Styled.ReviewTitle>
      <Styled.FeedbackSelector
        selectedTab={selectedTab}
        tabs={tabs}
        onSelectTab={handleTabSelection}
        variant={true}
      ></Styled.FeedbackSelector>
      {hasChips ? (
        <Styled.Tags>
          {chips.map((chip) => (
            <DisplayTag
              key={chip.name}
              shade={chipShade}
              data-testid={`display-tag-${chip.name}`}
              as="li"
            >
              {chip.name}
              <Styled.DisplayTagSpacer>•</Styled.DisplayTagSpacer>
              {chip.count}
            </DisplayTag>
          ))}
        </Styled.Tags>
      ) : (
        <Styled.ReviewSubTitle data-testid={'review-sub-title'}>
          There are no {selectedTab === 'positive' ? 'positive' : 'negative'}{' '}
          reviews to display yet.
        </Styled.ReviewSubTitle>
      )}
    </Styled.Feedback>
  );
};

export { RatingFeedbackChips };
